module.exports = __webpack_public_path__ + "img/pic9.992fead8.png";